import { Dispatch } from 'redux'
import { throwErrorWithMessage } from 'api/apiMessages'
import { AppState } from 'store/types'
import socketApi from 'utils/socketApi'

import * as UserApi from './User.api'
import * as UserTypes from './User.types'
import { getUserFirebaseIdToken } from './User.utils'

export const signOut = (dispatch: Dispatch<UserTypes.LogoutAction>) => {
  const domain = process.env.REACT_APP_DOMAIN ? ` Domain=${process.env.REACT_APP_DOMAIN}` : ''
  document.cookie = `token=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;${domain}`
  window.location.reload()

  return dispatch({ type: UserTypes.UserServiceActionTypes.LOGOUT })
}

// export const updateValues = (data: Partial<UserTypes.User>) => (dispatch: Dispatch<UserTypes.UpdateUserAction>) => {
//   dispatch({ type: UserTypes.UserServiceActionTypes.UPDATE_USER, data })
// }

// export const setOnboardingCompleted = (dispatch: Dispatch<UserTypes.SetUserOnboardingCompletedAction>) => {
//   dispatch({ type: UserTypes.UserServiceActionTypes.SET_USER_ONBOARDING_COMPLETED })
// }

// export const dismissRateUsPopup = (dispatch: Dispatch<UserTypes.DismissRateUsPopupAction>) => {
//   dispatch({ type: UserTypes.UserServiceActionTypes.DISSMISS_RATE_US_POPUP })
// }

// export const setNpsModalDisplayed = (displayed: boolean) => (
//   dispatch: Dispatch<UserTypes.SetNpsModalDisplayedAction>
// ) => {
//   dispatch({ type: UserTypes.UserServiceActionTypes.SET_NPS_MODAL_DISPLAYED, displayed })
// }

// export const loadCandidateUser = (candidate: UserTypes.User) => (
//   dispatch: Dispatch<UserTypes.SetCandidateUserAction>
// ) => {
//   dispatch({ type: UserTypes.UserServiceActionTypes.SET_CANDIDATE, candidate })
// }

// export const phoneNumberSignIn = async (phoneNumber: string, code: string) => {
//   const {
//     data: { token, user }
//   } = await UserApi.phoneNumberLogin(phoneNumber, code)

//   if (token && user) {
//     await AsyncStorageService.token.set(token)
//     return user
//   }

//   return null
// }

// export const phoneNumberSignUp = async (data: UserTypes.PhoneNumberSignUpData) => {
//   const {
//     data: { token, user }
//   } = await UserApi.phoneNumberCreateAccount(data)

//   if (token && user) {
//     await AsyncStorageService.token.set(token)
//     return user._id
//   }
// }

// export const setUserEmail = (email: string) =>
//   async function (dispatch: Dispatch<UserTypes.UpdateUserAction>) {
//     const { data } = await UserApi.patchUserEmail(email)

//     if (data.token) {
//       // We need to set the new token as it it being refreshed when the email changes.
//       // This is due to some specifics on the backend
//       await AsyncStorageService.token.set(data.token)
//     }

//     dispatch({
//       type: UserTypes.UserServiceActionTypes.UPDATE_USER,
//       data: { email }
//     })
//   }

// export const asyncSignUp = async (data: UserTypes.SignUpData) => {
//   const {
//     data: { token, user }
//   } = await UserApi.signUpUser(data)

//   if (token && user) {
//     await AsyncStorageService.token.set(token)

//     return user._id
//   }
// }

export const asyncSignIn = (username: string, password: string) => {
  return async (dispatch: Dispatch<UserTypes.LoadUserAction>) => {
    try {
      const {
        data: { token, user }
      } = await UserApi.signInUser(username, password)

      const domain = process.env.REACT_APP_DOMAIN ? ` Domain=${process.env.REACT_APP_DOMAIN}` : ''
      const expires = `expires=Fri, 31 Dec 9999 23:59:59 GMT`
      document.cookie = `token=${token}; ${expires}; path=/; ${domain}`
      socketApi.connect()

      dispatch({ type: UserTypes.UserServiceActionTypes.SET_USER, user })

      return user
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

// export const asyncSocialSignUp = (method: UserTypes.SocialAuthMethod, data: UserTypes.AsyncCreateProfileData) => {
//   return async (dispatch: Dispatch<UserTypes.LoadUserAction>) => {
//     const firebaseIdToken = await getUserFirebaseIdToken(method)

//     const {
//       data: { token, user }
//     } = await UserApi.signUpUserViaSocial({ profile: data, ssoProvider: method, firebaseIdToken })

//     if (token && user) {
//       await AsyncStorageService.token.set(token)

//       dispatch({ type: UserTypes.UserServiceActionTypes.SET_USER, user })

//       return user._id
//     }
//   }
// }

export const asyncSocialSignIn = (method: UserTypes.SocialAuthMethod) => {
  return async (dispatch: Dispatch<UserTypes.LoadUserAction>) => {
    try {
      const firebaseIdToken = await getUserFirebaseIdToken(method)
      const {
        data: { user, token }
      } = await UserApi.signInUserViaSocial(firebaseIdToken)

      const domain = process.env.REACT_APP_DOMAIN ? ` Domain=${process.env.REACT_APP_DOMAIN}` : ''
      const expires = `expires=Fri, 31 Dec 9999 23:59:59 GMT`
      document.cookie = `token=${token}; ${expires}; path=/; ${domain}`
      socketApi.connect()

      dispatch({ type: UserTypes.UserServiceActionTypes.SET_USER, user })

      return user
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const asyncGetCurrent = () => {
  return async (dispatch: Dispatch<UserTypes.LoadUserAction>) => {
    try {
      const { data: user } = await UserApi.getUser()
      socketApi.connect()

      dispatch({ type: UserTypes.UserServiceActionTypes.SET_USER, user })

      return user
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

// export const asyncGetUpdateLists = () => {
//   return async (dispatch: Dispatch<UserTypes.SetUpdateListAction>) => {
//     const { data } = await UserApi.getUpdateLists()

//     dispatch({ type: UserTypes.UserServiceActionTypes.SET_UPDATE_LIST, lists: data })
//     return data
//   }
// }

// export const asyncChangeUserEmail = (email: string) => {
//   return async (dispatch: Dispatch<UserTypes.LoadUserAction>) => {
//     const { data } = await UserApi.changeUserEmail(email)

//     if (data.token) {
//       await AsyncStorageService.token.set(data.token)
//     }

//     dispatch({ type: UserTypes.UserServiceActionTypes.SET_USER, user: data.user })
//   }
// }

// export const asyncChangeUserPassword = (oldPassword: string, newPassword: string) => {
//   return async (dispatch: Dispatch<UserTypes.LoadUserAction>) => {
//     const { data } = await UserApi.changeUserPassword(oldPassword, newPassword)

//     if (data.token) {
//       await AsyncStorageService.token.set(data.token)
//     }

//     dispatch({ type: UserTypes.UserServiceActionTypes.SET_USER, user: data.user })
//   }
// }

export const asyncCreateProfile = (profileData: UserTypes.AsyncCreateProfileData) => {
  return async (dispatch: Dispatch<UserTypes.CreateUserProfileAction>) => {
    try {
      const { data } = await UserApi.createProfile(profileData)

      return dispatch({ type: UserTypes.UserServiceActionTypes.UPDATE_USER_PROFILE, userProfile: data.profile })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const asyncUpdateUserProfile = (profileData: UserTypes.ProfileUpdate | FormData) => {
  return async (dispatch: Dispatch<UserTypes.UpdateUserProfileAction>) => {
    try {
      const { data } = await UserApi.updateUserProfile(profileData)

      return dispatch({ type: UserTypes.UserServiceActionTypes.UPDATE_USER_PROFILE, userProfile: data.profile })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

export const asyncCompleteOnboarding = (onboardingCompleted: boolean = true) => {
  return async (dispatch: Dispatch<UserTypes.SetUserOnboardingCompletedAction>) => {
    try {
      await UserApi.updateUser({ onboardingCompleted })

      return dispatch({ type: UserTypes.UserServiceActionTypes.SET_USER_ONBOARDING_COMPLETED })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

// export const asyncChangeNotificationsSettings = (notificationSettings: UserTypes.UserNotificationsSettings) => {
//   return async (dispatch: Dispatch<UserTypes.SetUserNotificationsSettingsAction>) => {
//     await UserApi.updateUser({ notificationSettings: notificationSettings })

//     dispatch({ type: UserTypes.UserServiceActionTypes.SET_USER_NOTIFICATIONS_SETTINGS, notificationSettings })
//   }
// }

// export const asyncChangeSoundSettings = (soundEffectsEnabled: boolean) => {
//   return async (dispatch: Dispatch<UserTypes.SetUserSoundSettingsAction>) => {
//     await UserApi.updateUser({ soundEffectsEnabled })
//     await AsyncStorageService.areSoundEffectsEnabled.set(soundEffectsEnabled)

//     dispatch({ type: UserTypes.UserServiceActionTypes.SET_USER_SOUND_SETTINGS, soundEffectsEnabled })
//   }
// }

// export const asyncSetNpsModalCompleted = (npsPopupCompleted: boolean) => {
//   return async (dispatch: Dispatch<UserTypes.SetUserNpsModalCompletedAction>) => {
//     await UserApi.updateUser({ npsPopupCompleted })
//     dispatch({ type: UserTypes.UserServiceActionTypes.SET_USER_NPS_MODAL_COMPLETED, completed: npsPopupCompleted })
//   }
// }

// export const asyncSetPrivateTutorLeadModalCompleted = () => {
//   return async (dispatch: Dispatch<UserTypes.SetUserPtModalCompletedAction>) => {
//     await UserApi.updateUser({ ptTrialInvitePopupCompleted: true })
//     dispatch({ type: UserTypes.UserServiceActionTypes.SET_USER_PT_LEAD_MODAL_COMPLETED, completed: true })
//   }
// }

export const asyncUpdateGlobalScore = (scoreToAdd: number, bookId?: string) => {
  return async (dispatch: Dispatch<UserTypes.UpdateUserProfileAction>, getState: () => AppState) => {
    try {
      const score = getState().user.entity?.profile?.globalScore
      if (typeof score !== 'number') return

      const res = await UserApi.updateUserScore({ score, scoreToAdd, bookId })

      return dispatch({ type: UserTypes.UserServiceActionTypes.UPDATE_USER_PROFILE, userProfile: res.data.profile })
    } catch (error) {
      return throwErrorWithMessage(error)
    }
  }
}

// export const setAccountPhoneNumber = (phoneNumber: string) => {
//   return async function (dispatch: Dispatch<UserTypes.UpdateUserAction>) {
//     const { data: userAndAccount } = await UserApi.updateUser({ phoneNumber })

//     dispatch({
//       type: UserTypes.UserServiceActionTypes.UPDATE_USER,
//       data: { phoneNumber: userAndAccount.phoneNumber }
//     })
//   }
// }
